__turbopack_context__.v({
  "active": "Stepper-module-scss-module__qCf0Wa__active",
  "number": "Stepper-module-scss-module__qCf0Wa__number",
  "section": "Stepper-module-scss-module__qCf0Wa__section",
  "step": "Stepper-module-scss-module__qCf0Wa__step",
  "stepList": "Stepper-module-scss-module__qCf0Wa__stepList",
  "stepped": "Stepper-module-scss-module__qCf0Wa__stepped",
  "tail": "Stepper-module-scss-module__qCf0Wa__tail",
});
